var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.635 58.762h4.527a1.5 1.5 0 1 0 0-3h-6.189L27.172 39.88h14.99a1.5 1.5 0 1 0 0-3H25.919a1.49 1.49 0 0 0-.38.054l-8.831-15.936h25.453a1.5 1.5 0 1 0 0-3H14.163a1.5 1.5 0 0 0-1.312 2.226l26.094 47.09a1.498 1.498 0 0 0 2.039.585 1.5 1.5 0 0 0 .585-2.039l-3.934-7.1Zm49.494-40.026a1.5 1.5 0 0 0-1.292-.738H57.838a1.5 1.5 0 0 0 0 3h25.453L74.49 36.88H57.838a1.5 1.5 0 0 0 0 3h14.99l-8.801 15.882h-6.189a1.5 1.5 0 0 0 0 3h4.527l-3.934 7.1a1.5 1.5 0 0 0 2.625 1.454l26.094-47.09c.257-.464.25-1.03-.021-1.488ZM57.424 76.412a1.498 1.498 0 0 0-2.086.385l-3.838 5.57V10.648a1.5 1.5 0 1 0-3 0v71.719l-3.838-5.57a1.5 1.5 0 1 0-2.47 1.701l6.573 9.54a1.499 1.499 0 0 0 2.47 0l6.573-9.54a1.5 1.5 0 0 0-.385-2.086Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.f407b0790faecfcbf1082147bf1dd1ae.svg";
export { ForwardRef as ReactComponent };